// src/main.ts
import { bootstrapApplication, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import {
  PreloadAllModules,
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';
import { routes } from './app/app.routes';
import { provideHttpClient } from '@angular/common/http';

// include appConfig.providers if any
const extraProviders = (appConfig && (appConfig as any).providers) ? (appConfig as any).providers : [];

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
      // withPreloading(PreloadAllModules)
    ),
    // THIS is mandatory for HttpClient to be available app-wide:
    provideHttpClient(),
    // preserve other appConfig providers:
    ...extraProviders, provideClientHydration(),
  ],
}).catch(err => console.error(err));
